import request from '../utils/request'
import QS from "qs";

export function getCartList () {
  return request({
    url: '/api/cart',
    method: 'get'
  })
}

export function upDataCart (id,data) { // 更新购物车商品数量（加减）
  return request({
    url: `/api/cart/${id}`,
    method: 'put',
    data:QS.stringify(data),
  })
}

export function cartClear () { // 清空购物车
  return request({
    url: '/api/cart/clear',
    method: 'delete'
  })
}
export function cartCheckout (data) { // 结算信息
  return request({
    url: '/api/cart/checkout',
    method: 'get',
    params: data,
  })
}

